import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";
import { PRAGATI_ACTION } from "../constant";

export const getUpcommingAgendaFlagAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_START
    });
    return requestMethod(apiServices.getUpcommingAgendaFlag(data))
      .then(resp => {
        const data = get(resp, "data");
        //console.log("response*******", data);
        dispatch({
          type: PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_SUCCESS,
          data
        });
      })
      .catch(() => {
        dispatch({
          type: PRAGATI_ACTION.GET_UPCOMMING_AGENDA_FLAG_FAILURE
        });
      });
  };
};
